import {isCreatorMode} from "../helpers/fns";

export const questionMixin = {
  props: {
    question: {
      type: Object,
      default: () => ({})
    },
  },
  computed: {
    buttonText() {
      return (
        this.question?.translations?.nextButton?.value ||
        this.survey?.translations?.questions?.nextButton?.value ||
        this.survey?.translations?.questions?.nextButton?.defaultValue
      )
    },
  },
  methods: {
    onAnswer(value, delay = 300) {
      setTimeout(
        () => this.$emit('next', {question_id: this.question._id, value}),
        delay
      );
    }
  }
};

export const questionEventListenerMixin = {
  mounted() {
    if (!isCreatorMode) {
      document.addEventListener('keydown', this.onKeyDown, false);
    }
  },
  beforeDestroy() {
    if (!isCreatorMode) {
      document.removeEventListener('keydown', this.onKeyDown, false);
    }
  }
};

export default questionMixin;
